import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { StatsigService } from '@statsig/angular-bindings';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, take, timeout } from 'rxjs/operators';
import { CiamFlagsService } from '@core/services/ciam-flags.service';
import { FeatureFlagService } from '@core/services/statsig';

const STATSIG_INIT_TIMEOUT_MS = 5000;

@Injectable()
export class CiamV6Guard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly ciamFlagsService: CiamFlagsService,
    private readonly featureFlags: FeatureFlagService,
    private readonly statsigService: StatsigService
  ) {}

  canActivate(): Observable<boolean> | boolean {
    if (this.featureFlags.isInitialized) {
      return this.resolveAccess();
    }

    return this.statsigService.isLoading$.pipe(
      filter((loading) => !loading),
      take(1),
      timeout(STATSIG_INIT_TIMEOUT_MS),
      map(() => this.resolveAccess()),
      catchError(() => of(this.resolveAccess()))
    );
  }

  private resolveAccess(): boolean {
    if (this.ciamFlagsService.isCiamV6Com()) {
      return true;
    }
    return this.denyAccess();
  }

  private denyAccess(): boolean {
    this.router.navigate(['/home']);
    return false;
  }
}
